import { Injectable } from '@angular/core';
import * as SockJs from 'sockjs-client';
import * as StompJs from 'stompjs';
import { BASE_URL } from "../utility/APIConstants";
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { Client, Message } from '@stomp/stompjs';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class StompService {
  private stompClient: Client;

  constructor(private _snackBar: MatSnackBar) { }

  connect(): void {
    const socket = new SockJS('http://localhost:8080/websocket'); // Replace with your WebSocket server URL
    this.stompClient = new Client();
    this.stompClient.webSocketFactory = () => socket;
    this.stompClient.onConnect = () => {
      console.log('Connected to WebSocket server');
      this.subscribe('/topic/report'); // Subscribe to a topic
    };
    this.stompClient.activate();
  }

  private subscribe(destination: string): void {
    this.stompClient.subscribe(destination, (message: Message) => {
      console.log('Received message:', message.body);
      // this._snackBar.open(
      //   message.body,
      //   null,
      //   {
      //     duration: 3000,
      //     verticalPosition: "top",
      //     panelClass: ["if-success"],
      //   }
      // );
      // Handle incoming messages here
    });
  }

  sendMessage(destination: string, message: string): void {
    this.stompClient.publish({ destination, body: message });
  }

  disconnect(): void {
    if (this.stompClient) {
      this.stompClient.deactivate();
    }
    console.log('Disconnected from WebSocket server');
  }
}